var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headNav'),_c('router-view',{staticStyle:{"min-height":"100vh","padding-top":"66px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }